<style scoped lang="less">
.modal-footer {
    display: block;
    text-align: center;
}
ul {
    list-style-type: none;
    padding-left: 5px;
}
.icon-download {
    text-decoration: none !important;
    &:before {
        margin-right: 5px;
        vertical-align: middle;
        color: #444444;
    }
}
</style>
<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">Form Submitted</h2>
            <button type="button" class="close icon icon-close" @click="$emit('close')" autofocus aria-label="Close" />
        </div>
        <div class="modal-body">
            <span class="action-success-icon icon icon-check" aria-hidden="true"></span>
            <p describedby-text class="action-success-text">Form submitted successfully.</p>
            <template v-if="receiptContents.length > 0">
                <br />
                <template v-for="receiptContent in receiptContents">
                    <div v-html="receiptContent"></div>
                </template>
            </template>
            <hr class="clearfix" />
            <template v-if="documents.length > 0">
                <h3 class="h5">Produced File{{ documents.length != 1 ? "s" : "" }}</h3>
                <ul>
                    <template v-for="document in documents">
                        <li v-if="document.text != 'All Documents'" class="mb-1">
                            <a download class="icon icon-download" @click="documentClick($event)" :href="adminPreview ? null : document.url" target="_blank" :aria-label="document.text">{{ document.text }}</a>
                        </li>
                        <li v-else>
                            <a download class="btn btn-sm btn-outline-secondary mt-2" @click="documentClick($event)" :href="adminPreview ? null : document.url" target="_blank">Download All</a>
                        </li>
                    </template>
                </ul>
            </template>
            <small><a download @click="documentClick($event)" :href="submissionUrl" target="_blank">Download Submission</a></small>
        </div>
        <div class="modal-footer">
            <a class="btn btn-outline-secondary" v-if="hasRedirect" :href="redirectUrl">Continue</a>
            <button class="btn btn-outline-secondary" tabindex="0" v-else @click.prevent="$emit('close')">Close</button>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
import { useMainStore } from "@/mainStore";
interface Props extends DialogProps {
    adminPreview: boolean;
    redirectUrl: string | null;
    /* eslint-disable @typescript-eslint/no-explicit-any*/ // TODO
    documents: any[];
    submissionUrl: string;
    receiptContents: string;
}
export default defineComponent({
    props: ["adminPreview", "redirectUrl", "documents", "submissionUrl", "receiptContents", "triggerElement"],
    setup(props: Props) {
        const mainStore = useMainStore();
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);
        const hasRedirect = computed(() => {
            return !!props.redirectUrl;
        });
        const documentClick = (event: Event) => {
            if (props.adminPreview) {
                alert("Documents are not generated on preview mode submission");
                event.preventDefault();
            } else {
                const statusMessage = new Promise<string>(resolve => setTimeout(() => resolve("Files have been successfully downloaded"), 2000));
                mainStore.setLiveRegion(statusMessage);
            }
        };

        return {
            container: containerRef,
            hasRedirect,
            documentClick,
        };
    },
});
</script>
